module.exports = __webpack_public_path__ + "img/task-board-component-namebg.110961b3.png";